import { render } from "./StatusesView.vue?vue&type=template&id=d35143c6&scoped=true"
import script from "./StatusesView.vue?vue&type=script&lang=js"
export * from "./StatusesView.vue?vue&type=script&lang=js"

import "./StatusesView.vue?vue&type=style&index=0&id=d35143c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35143c6"]])

export default __exports__